__turbopack_context__.v({
  "container": "AboutUsContainer-module-scss-module__RMdLOq__container",
});
